<!-- 企业级-业务领域-仓储业务-添加预约单 -->
<template>
  <div class="mainArea CAddBook">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-form :model="addForm" :inline="true">
            <el-form-item label="库位">
              <el-cascader
                v-model="addForm.Location"
                :options="LocationList"
                :props="{ checkStrictly: true }"
                clearable></el-cascader>
            </el-form-item>
            <el-form-item label="盘点时间">
              <el-date-picker
                v-model="addForm.time"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary">添加</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table v-loading="loading" :data="bookData" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="盘点单号" prop=""></el-table-column>
          <el-table-column label="库位" prop=""></el-table-column>
          <el-table-column label="盘点时间" prop=""></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text">修改</el-button>
              <el-button type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
        <!-- <div class="btnDiv">
          <el-button size="medium" @click="backUp">取消</el-button>
          <el-button size="medium" type="primary">确定</el-button>
        </div> -->
      </div>

      <el-dialog :title="dioTitle" :visible.sync="bookDio" :width="dioWidth" class="configDio" center>
        <div class="contDio">
          <el-form ref="form" :model="dioform">
            <el-form-item label="库位">
              <el-cascader
                v-model="dioform.Location"
                :options="LocationList"
                :props="{ checkStrictly: true }"
                clearable></el-cascader>
            </el-form-item>
            <el-form-item label="盘点时间">
              <el-date-picker
                v-model="dioform.time"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer">
          <el-button @click="bookDio = false">取消</el-button>
          <el-button type="primary">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'CAddBook',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        LocationList:[],//库位树形数据

        addForm:{
          Location:'',//库位
          time:'',//时间
        },

        loading:false,
        bookData:[],//仓库数据

        //分页
        curr:1,
        limits:10,
        total:0,

        bookDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        dioform:{
          Location:'',
          time:'',
        },
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      //打开弹窗
      openDio(type){
        this.dioType = type
        if(type == 'edit'){
          this.dioWidth="800px"
          this.dioTitle="修改盘点单"
        }
        this.bookDio = true
      },
      //弹窗分页
      CurrDioChange(val){
        this.dioform.curr = val
        //执行方法
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
      },
      //返回上一页
      backUp(){
        this.$router.push({
          path:'/CStoreRecord'
        })
      }
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CAddBook{
  .w200{
    width: 200px;
  }
  .w235{
    width: 235px;
  }
  .w300{
    width: 300px;
  }
  .w480{
    width: 480px;
  }
  .btnDiv{
    margin-top: 20px;
    text-align: right;
  }
  .searchBox {
    margin-bottom: 20px;
    .el-form-item{
      margin-bottom: 10px;
      vertical-align: bottom;
      .el-form-item__label{
        display: block;
        float: none;
        text-align: left;
        line-height: 24px;
      }
    }
    
  }
  .contDio{
    .el-form-item{
      margin-bottom: 10px;
      .el-form-item__content{
        line-height: 1.5;
      }
    }
  }
  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CStoreRecord/CAddStore.vue